export default [
  {
    path: 'databaseManager',
    meta: {
      title: '数据库管理'
    },
    component: () => import('../pages/database/DatabaseManager.vue'),
  },
]
